import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { Spinner } from "../components/ui/kit";
import api from "../lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    (async () => {
      try {
        await api.post("/api/auth/verify-email", { token });
        setState("ok");
      } catch (e) {
        setState("error");
      }
    })();
  }, [token]);

  return (
    <AuthShell title="Ověření e-mailu"
      footer={<Link to="/" className="text-accent font-600">Přejít do aplikace</Link>}>
      {state === "loading" && (
        <div className="flex items-center gap-2 text-muted"><Spinner /> Ověřuji…</div>
      )}
      {state === "ok" && (
        <div className="card p-5 text-[13px] text-success" data-testid="verify-ok">
          E-mail je ověřený. Díky!
        </div>
      )}
      {state === "error" && (
        <div className="card p-5 text-[13px] text-danger" data-testid="verify-error">
          Odkaz je neplatný nebo vypršel.
        </div>
      )}
    </AuthShell>
  );
}
